// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var _a;
// What the signing widget asks of Harvest (design §5). Components take the
// `ISigningApi` interface, so stories and tests hand them a fake; only
// `createSigningApi` knows the transport: the Hasura actions that forward to
// the Harvest routes, like the portal's other Harvest calls.
//
// Contract of the Hasura actions (all synchronous, handler = the Harvest route;
// a `jsonb` output field carries the route's JSON as is):
//
//   query    signingGetRequest(request_id: uuid!): {panel: jsonb!}
//            POST /signing-requests/get. `panel` = ISigningPanelData: the
//            ISigningRequestPanel {request, rule, count, signers, document_url};
//            signers are {user_id, username, display_name, title, is_you,
//            status, signed_at, certificate_cn}
//            plus the optional election_name, area_name, document_name,
//            document_pages, details [{key, label?, value}], and time_zone
//            (the election event's primary IANA zone from its
//            presentation.timezones, e.g. "Asia/Manila"; "UTC" when it names none).
//   mutation signingCheckCertificate(request_id: uuid!, chain_pem: [String!]!):
//            {checks: jsonb!, certificate, registration, revocation_status} (the widget reads checks)
//            POST …/check-certificate. `checks` = [{id, ok, detail}] (CertificateCheckId).
//            detail: trusted-issuer → the root's name; not-revoked → when the CRL
//            was fetched (RFC 3339); registered → the registration time, null on a
//            first use; registered-to-other → the other person's name.
//   mutation signingPdfPrepare(request_id: uuid!, chain_pem: [String!]!):
//            {revision: Int!, digest_b64: String!, signing_time: String!}
//   mutation signingApprove(request_id: uuid!, chain_pem: [String!]!, algorithm: String!,
//            payload_signature_b64: String!, document_signature_b64: String,
//            pdf_cms_b64: String, revision: Int): {status: String!, count: Int!, required: Int!}
//   mutation signingOpenFailure(request_id: uuid!, file_name: String!, reason: String!): {request_id: uuid!}
//            reason = CertificateOpenFailure (wrong-password | unreadable | no-key).
//   mutation signingHandover(request_id: uuid!): {request_id: uuid!}
//   mutation signingCancel(request_id: uuid!, reason: String): {request_id: uuid!}
//
// Each call sends an explicit `x-hasura-role` the action allows and the user
// holds (roles.ts), so staff without admin-user don't get the portal's
// read-only default.
//
// Errors: Harvest answers `{"message", "extensions": {"code", "check"?, "status"?}}`
// (the codes below, as harvest's signing routes answer them); Hasura
// forwards `extensions` into the GraphQL error. The widget reads
// `extensions.code` first and the HTTP status only when no code is given
// (kept in extensions.internal.response).
//   signing-refused  (422) a certificate check refused the approval; `check` = CertificateCheckId
//   already-signed   (422) this person, certificate, key or holder already signed it
//   request-closed   (409) the request is no longer waiting (`status` = its status) or expired
//   stale-revision   (409) the prepared PDF revision is stale: the only case prepared again
//   forbidden        (403) the permission is missing
//   not-found (404), invalid (400), conflict (409), locked-down (409): shown as a failure
// A 409 without a code counts as stale-revision.
//
// `details` rows label subject fields: `key` must be a key of the payload's
// subject and `value` its display form (strings as is, numbers as text,
// arrays joined with ", "); the dialog refuses any other row. The Post and
// country names are labels of the payload's election_id and area_id.
import { gql } from "@apollo/client";
import { parseActionResponseBody } from "@/services/graphqlActionError";
import { SigningOperation, signingOperationRole } from "./roles";
import { CertificateCheckId, } from "./types";
export var SigningApiErrorKind;
(function (SigningApiErrorKind) {
    /** A certificate check refused the approval; `check` names it. */
    SigningApiErrorKind["Refused"] = "refused";
    /** The prepared PDF revision is stale; prepare again. */
    SigningApiErrorKind["Stale"] = "stale";
    SigningApiErrorKind["AlreadySigned"] = "already-signed";
    /** The request no longer waits for signatures. */
    SigningApiErrorKind["Closed"] = "closed";
    SigningApiErrorKind["Forbidden"] = "forbidden";
    SigningApiErrorKind["Other"] = "other";
})(SigningApiErrorKind || (SigningApiErrorKind = {}));
/** The `extensions.code` values of the signing routes. */
export var SigningErrorCode;
(function (SigningErrorCode) {
    SigningErrorCode["Refused"] = "signing-refused";
    SigningErrorCode["StaleRevision"] = "stale-revision";
    SigningErrorCode["AlreadySigned"] = "already-signed";
    SigningErrorCode["RequestClosed"] = "request-closed";
    SigningErrorCode["Forbidden"] = "forbidden";
})(SigningErrorCode || (SigningErrorCode = {}));
var KIND_OF_CODE = (_a = {},
    _a[SigningErrorCode.Refused] = SigningApiErrorKind.Refused,
    _a[SigningErrorCode.StaleRevision] = SigningApiErrorKind.Stale,
    _a[SigningErrorCode.AlreadySigned] = SigningApiErrorKind.AlreadySigned,
    _a[SigningErrorCode.RequestClosed] = SigningApiErrorKind.Closed,
    _a[SigningErrorCode.Forbidden] = SigningApiErrorKind.Forbidden,
    _a);
var KIND_OF_STATUS = {
    422: SigningApiErrorKind.Refused,
    409: SigningApiErrorKind.Stale,
    403: SigningApiErrorKind.Forbidden,
    401: SigningApiErrorKind.Forbidden,
};
var SigningApiError = /** @class */ (function (_super) {
    __extends(SigningApiError, _super);
    function SigningApiError(kind, message, _a) {
        var _b = _a.status, status = _b === void 0 ? null : _b, _c = _a.check, check = _c === void 0 ? null : _c;
        var _this = _super.call(this, message) || this;
        // The portal compiles to ES5, where an Error subclass loses its prototype: restore it
        // so `instanceof SigningApiError` holds in the production build.
        Object.setPrototypeOf(_this, SigningApiError.prototype);
        _this.name = "SigningApiError";
        _this.kind = kind;
        _this.status = status;
        _this.check = check;
        return _this;
    }
    return SigningApiError;
}(Error));
export { SigningApiError };
var CHECK_IDS = new Set(Object.values(CertificateCheckId));
var record = function (value) {
    return value && typeof value === "object" ? value : {};
};
var checkIdOf = function () {
    var _a;
    var candidates = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        candidates[_i] = arguments[_i];
    }
    return (_a = candidates.find(function (c) { return typeof c === "string" && CHECK_IDS.has(c); })) !== null && _a !== void 0 ? _a : null;
};
/**
 * Classifies a failed Hasura action by Harvest's `extensions.code`, promoted
 * by Hasura or left in the forwarded body, and by the HTTP status when no
 * code is given.
 */
export var toSigningApiError = function (error) {
    var _a, _b, _c, _d, _e;
    if (error instanceof SigningApiError) {
        return error;
    }
    var actionError = error;
    for (var _i = 0, _f = (_a = actionError === null || actionError === void 0 ? void 0 : actionError.graphQLErrors) !== null && _a !== void 0 ? _a : []; _i < _f.length; _i++) {
        var graphQLError = _f[_i];
        var extensions = record(graphQLError.extensions);
        var response = (_c = (_b = graphQLError.extensions) === null || _b === void 0 ? void 0 : _b.internal) === null || _c === void 0 ? void 0 : _c.response;
        var status_1 = typeof (response === null || response === void 0 ? void 0 : response.status) === "number" ? response.status : null;
        var rawBody = (_d = response === null || response === void 0 ? void 0 : response.body) !== null && _d !== void 0 ? _d : undefined;
        var body = record(parseActionResponseBody(rawBody));
        var bodyExtensions = record(body.extensions);
        var code = [extensions.code, bodyExtensions.code, body.code].find(function (c) { return typeof c === "string" && c in KIND_OF_CODE; });
        var kind = code
            ? KIND_OF_CODE[code]
            : status_1 !== null
                ? KIND_OF_STATUS[status_1]
                : undefined;
        if (kind) {
            var check = kind === SigningApiErrorKind.Refused
                ? checkIdOf(extensions.check, bodyExtensions.check, body.check, body.id, bodyExtensions.code, body.code, rawBody === null || rawBody === void 0 ? void 0 : rawBody.trim())
                : null;
            return new SigningApiError(kind, (_e = graphQLError.message) !== null && _e !== void 0 ? _e : "signing request failed", {
                status: status_1,
                check: check,
            });
        }
    }
    var message = error instanceof Error ? error.message : String(error);
    return new SigningApiError(SigningApiErrorKind.Other, message, {});
};
var isString = function (value) { return typeof value === "string"; };
var isStringOrNull = function (value) { return value === null || value === undefined || isString(value); };
/**
 * Refuses an answer that isn't a panel, so a malformed response shows as a
 * load failure instead of breaking the page.
 */
export var validatePanel = function (value) {
    var panel = record(value);
    var request = record(panel.request);
    var rule = record(panel.rule);
    var valid = ["id", "tenant_id", "election_event_id", "action", "status", "code"].every(function (field) {
        return isString(request[field]);
    }) &&
        isString(request.canonical_payload) &&
        isString(request.payload_sha256) &&
        typeof request.required === "number" &&
        isStringOrNull(request.expires_at) &&
        isStringOrNull(request.document_sha256) &&
        isString(rule.requester_signing) &&
        typeof panel.count === "number" &&
        Array.isArray(panel.signers) &&
        panel.signers.every(function (signer) {
            var s = record(signer);
            return (isString(s.user_id) &&
                isString(s.username) &&
                isString(s.display_name) &&
                isStringOrNull(s.signed_at));
        }) &&
        isStringOrNull(panel.document_url) &&
        (panel.details === undefined ||
            panel.details === null ||
            (Array.isArray(panel.details) &&
                panel.details.every(function (d) { return isString(record(d).key) && isString(record(d).value); })));
    if (!valid) {
        throw new SigningApiError(SigningApiErrorKind.Other, "the signing request is malformed", {});
    }
    return value;
};
export var SIGNING_REQUEST = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    query SigningGetRequest($request_id: uuid!) {\n        signingGetRequest(request_id: $request_id) {\n            panel\n        }\n    }\n"], ["\n    query SigningGetRequest($request_id: uuid!) {\n        signingGetRequest(request_id: $request_id) {\n            panel\n        }\n    }\n"])));
export var SIGNING_CHECK_CERTIFICATE = gql(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    mutation SigningCheckCertificate($request_id: uuid!, $chain_pem: [String!]!) {\n        signingCheckCertificate(request_id: $request_id, chain_pem: $chain_pem) {\n            checks\n        }\n    }\n"], ["\n    mutation SigningCheckCertificate($request_id: uuid!, $chain_pem: [String!]!) {\n        signingCheckCertificate(request_id: $request_id, chain_pem: $chain_pem) {\n            checks\n        }\n    }\n"])));
export var SIGNING_PDF_PREPARE = gql(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    mutation SigningPdfPrepare($request_id: uuid!, $chain_pem: [String!]!) {\n        signingPdfPrepare(request_id: $request_id, chain_pem: $chain_pem) {\n            revision\n            digest_b64\n            signing_time\n        }\n    }\n"], ["\n    mutation SigningPdfPrepare($request_id: uuid!, $chain_pem: [String!]!) {\n        signingPdfPrepare(request_id: $request_id, chain_pem: $chain_pem) {\n            revision\n            digest_b64\n            signing_time\n        }\n    }\n"])));
export var SIGNING_APPROVE = gql(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    mutation SigningApprove(\n        $request_id: uuid!\n        $chain_pem: [String!]!\n        $algorithm: String!\n        $payload_signature_b64: String!\n        $document_signature_b64: String\n        $pdf_cms_b64: String\n        $revision: Int\n    ) {\n        signingApprove(\n            request_id: $request_id\n            chain_pem: $chain_pem\n            algorithm: $algorithm\n            payload_signature_b64: $payload_signature_b64\n            document_signature_b64: $document_signature_b64\n            pdf_cms_b64: $pdf_cms_b64\n            revision: $revision\n        ) {\n            status\n            count\n            required\n        }\n    }\n"], ["\n    mutation SigningApprove(\n        $request_id: uuid!\n        $chain_pem: [String!]!\n        $algorithm: String!\n        $payload_signature_b64: String!\n        $document_signature_b64: String\n        $pdf_cms_b64: String\n        $revision: Int\n    ) {\n        signingApprove(\n            request_id: $request_id\n            chain_pem: $chain_pem\n            algorithm: $algorithm\n            payload_signature_b64: $payload_signature_b64\n            document_signature_b64: $document_signature_b64\n            pdf_cms_b64: $pdf_cms_b64\n            revision: $revision\n        ) {\n            status\n            count\n            required\n        }\n    }\n"])));
export var SIGNING_OPEN_FAILURE = gql(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    mutation SigningOpenFailure($request_id: uuid!, $file_name: String!, $reason: String!) {\n        signingOpenFailure(request_id: $request_id, file_name: $file_name, reason: $reason) {\n            request_id\n        }\n    }\n"], ["\n    mutation SigningOpenFailure($request_id: uuid!, $file_name: String!, $reason: String!) {\n        signingOpenFailure(request_id: $request_id, file_name: $file_name, reason: $reason) {\n            request_id\n        }\n    }\n"])));
export var SIGNING_HANDOVER = gql(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    mutation SigningHandover($request_id: uuid!) {\n        signingHandover(request_id: $request_id) {\n            request_id\n        }\n    }\n"], ["\n    mutation SigningHandover($request_id: uuid!) {\n        signingHandover(request_id: $request_id) {\n            request_id\n        }\n    }\n"])));
export var SIGNING_CANCEL = gql(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    mutation SigningCancel($request_id: uuid!, $reason: String) {\n        signingCancel(request_id: $request_id, reason: $reason) {\n            request_id\n        }\n    }\n"], ["\n    mutation SigningCancel($request_id: uuid!, $reason: String) {\n        signingCancel(request_id: $request_id, reason: $reason) {\n            request_id\n        }\n    }\n"])));
/** The production api: one Hasura action per Harvest route. */
export var createSigningApi = function (client, fetchImpl, _a) {
    if (fetchImpl === void 0) { fetchImpl = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return fetch.apply(void 0, args);
    }; }
    var _b = _a === void 0 ? {} : _a, holds = _b.holds;
    // The action of each request loaded, so its calls send its sign permission.
    var actions = new Map();
    var context = function (operation, requestId) {
        var _a;
        var role = holds
            ? signingOperationRole(operation, (_a = actions.get(requestId)) !== null && _a !== void 0 ? _a : null, holds)
            : null;
        return role ? { headers: { "x-hasura-role": role } } : undefined;
    };
    var mutate = function (operation, mutation, field, variables) { return __awaiter(void 0, void 0, void 0, function () {
        var data, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, client.mutate({
                            mutation: mutation,
                            variables: variables,
                            fetchPolicy: "no-cache",
                            context: context(operation, variables.request_id),
                        })];
                case 1:
                    data = (_a.sent()).data;
                    return [2 /*return*/, record(data)[field]];
                case 2:
                    error_1 = _a.sent();
                    throw toSigningApiError(error_1);
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var sign = function (mutation, field, variables) {
        return mutate(SigningOperation.Sign, mutation, field, variables);
    };
    return {
        getRequest: function (requestId) { return __awaiter(void 0, void 0, void 0, function () {
            var data, panel, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, client.query({
                                query: SIGNING_REQUEST,
                                variables: { request_id: requestId },
                                fetchPolicy: "no-cache",
                                context: context(SigningOperation.GetRequest, requestId),
                            })];
                    case 1:
                        data = (_a.sent()).data;
                        panel = validatePanel(record(record(data).signingGetRequest).panel);
                        actions.set(requestId, panel.request.action);
                        return [2 /*return*/, panel];
                    case 2:
                        error_2 = _a.sent();
                        throw toSigningApiError(error_2);
                    case 3: return [2 /*return*/];
                }
            });
        }); },
        checkCertificate: function (requestId, input) {
            return sign(SIGNING_CHECK_CERTIFICATE, "signingCheckCertificate", __assign({ request_id: requestId }, input));
        },
        pdfPrepare: function (requestId, input) {
            return sign(SIGNING_PDF_PREPARE, "signingPdfPrepare", __assign({ request_id: requestId }, input));
        },
        approve: function (requestId, input) {
            return sign(SIGNING_APPROVE, "signingApprove", __assign({ request_id: requestId }, input));
        },
        reportOpenFailure: function (requestId, input) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sign(SIGNING_OPEN_FAILURE, "signingOpenFailure", __assign({ request_id: requestId }, input))];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        handover: function (requestId) { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sign(SIGNING_HANDOVER, "signingHandover", { request_id: requestId })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        cancel: function (requestId, input) { return __awaiter(void 0, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, mutate(SigningOperation.Cancel, SIGNING_CANCEL, "signingCancel", {
                            request_id: requestId,
                            reason: (_a = input.reason) !== null && _a !== void 0 ? _a : null,
                        })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); },
        fetchDocument: function (url) { return __awaiter(void 0, void 0, void 0, function () {
            var response, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, fetchImpl(url)];
                    case 1:
                        response = _b.sent();
                        if (!response.ok) {
                            throw new SigningApiError(SigningApiErrorKind.Other, "document download failed: ".concat(response.status), { status: response.status });
                        }
                        _a = Uint8Array.bind;
                        return [4 /*yield*/, response.arrayBuffer()];
                    case 2: return [2 /*return*/, new (_a.apply(Uint8Array, [void 0, _b.sent()]))()];
                }
            });
        }); },
    };
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7;
